export const FEATURED_GENERIC_PROD = [{
  type: 'track',
  id: '39'
}, {
  type: 'track',
  id: '60'
}, {
  type: 'track',
  id: '44'
}, {
  type: 'track',
  id: '12'
}, {
  type: 'track',
  id: '5'
}, {
  type: 'all',
  to: '/results?tools=MARKETING_HUB_TOOLS&tools=SERVICE_HUB_TOOLS&tools=SALES_HUB_TOOLS'
}];
export const FEATURED_GENERIC_QA = [{
  type: 'track',
  id: '407009'
}, {
  type: 'track',
  id: '402106'
}, {
  type: 'track',
  id: '162869'
}, {
  type: 'track',
  id: '338414'
}, {
  type: 'track',
  id: '324113'
}, {
  type: 'all',
  to: '/results?tools=MARKETING_HUB_TOOLS&tools=SERVICE_HUB_TOOLS&tools=SALES_HUB_TOOLS'
}];
export const FEATURED_BY_FIELD_PROD = {
  marketing: [{
    type: 'track',
    id: '4'
  }, {
    type: 'track',
    id: '5'
  }, {
    type: 'track',
    id: '60'
  }, {
    type: 'track',
    id: '78'
  }, {
    type: 'track',
    id: '112'
  }, {
    type: 'all',
    to: '/results?tools=MARKETING_HUB_TOOLS'
  }],
  sales: [{
    type: 'track',
    id: '39'
  }, {
    type: 'track',
    id: '12'
  }, {
    type: 'track',
    id: '44'
  }, {
    type: 'track',
    id: '110'
  }, {
    type: 'lesson',
    id: '98'
  }, {
    type: 'all',
    to: '/results?tools=SALES_HUB_TOOLS'
  }],
  'services-support': [{
    type: 'track',
    id: '1003125'
  }, {
    type: 'track',
    id: '97'
  }, {
    type: 'track',
    id: '98'
  }, {
    type: 'track',
    id: '1015124'
  }, {
    type: 'lesson',
    id: '570'
  }, {
    type: 'all',
    to: '/results?tools=SERVICE_HUB_TOOLS'
  }],
  'administration-operations': [{
    type: 'lesson',
    id: '339'
  }, {
    type: 'lesson',
    id: '1017821'
  }, {
    type: 'lesson',
    id: '272'
  }, {
    type: 'lesson',
    id: '478'
  }, {
    type: 'lesson',
    id: '42'
  }, {
    type: 'lesson',
    id: '314'
  }],
  other: FEATURED_GENERIC_PROD
};
export const FEATURED_BY_FIELD_QA = {
  marketing: FEATURED_GENERIC_QA,
  sales: FEATURED_GENERIC_QA,
  'services-support': FEATURED_GENERIC_QA,
  'administration-operations': FEATURED_GENERIC_QA,
  other: FEATURED_GENERIC_QA
};
export const FEATURED_BY_LANGUAGE_PROD = {
  fr: [{
    type: 'lesson',
    id: '311'
  }, {
    type: 'lesson',
    id: '237'
  }, {
    type: 'lesson',
    id: '425'
  }, {
    type: 'lesson',
    id: '42'
  }, {
    type: 'lesson',
    id: '314'
  }, {
    type: 'lesson',
    id: '749'
  }],
  es: [{
    type: 'lesson',
    id: '311'
  }, {
    type: 'lesson',
    id: '237'
  }, {
    type: 'lesson',
    id: '425'
  }, {
    type: 'lesson',
    id: '42'
  }, {
    type: 'lesson',
    id: '314'
  }, {
    type: 'lesson',
    id: '749'
  }],
  de: [{
    type: 'lesson',
    id: '311'
  }, {
    type: 'lesson',
    id: '237'
  }, {
    type: 'lesson',
    id: '425'
  }, {
    type: 'lesson',
    id: '42'
  }, {
    type: 'lesson',
    id: '314'
  }, {
    type: 'lesson',
    id: '749'
  }],
  jp: [{
    type: 'lesson',
    id: '311'
  }, {
    type: 'lesson',
    id: '237'
  }, {
    type: 'lesson',
    id: '425'
  }, {
    type: 'lesson',
    id: '42'
  }, {
    type: 'lesson',
    id: '314'
  }, {
    type: 'lesson',
    id: '749'
  }],
  'pt-br': [{
    type: 'lesson',
    id: '311'
  }, {
    type: 'lesson',
    id: '237'
  }, {
    type: 'lesson',
    id: '425'
  }, {
    type: 'lesson',
    id: '42'
  }, {
    type: 'lesson',
    id: '314'
  }, {
    type: 'lesson',
    id: '46'
  }]
};
export const FEATURED_BY_LANGUAGE_QA = {
  fr: FEATURED_GENERIC_QA,
  es: FEATURED_GENERIC_QA,
  de: FEATURED_GENERIC_QA,
  jp: FEATURED_GENERIC_QA,
  'pt-br': FEATURED_GENERIC_QA
};
export const SOFTWARE_TABS = ['marketing', 'sales', 'services-support', 'administration-operations', 'other'];